import { Modal } from '@/components/Modal';
import { contactUs } from '@/hooks/useUpgrade';
import { useGlobalState } from '@/state/global.state';

export const UpgradeModal = () => {
  const {
    modal: { upgrade: upgradeState },
  } = useGlobalState();

  return (
    <Modal
      title={'Free Upgrade'}
      size="3xl"
      open={upgradeState.open}
      onClose={() => upgradeState.onOpenChange(false)}
      footer={{
        className: 'w-32',
        text: 'Free Upgrade',
        onClick: () => {
          contactUs();
          upgradeState.onOpenChange(false);
        },
      }}
    >
      <div className="text-chariot-text-primary flex flex-col p-2">
        <div className="mb-6 text-center">
          <p className="text-2xl font-semibold">Free Managed-Service Trial</p>
          <p className="text-chariot-text-secondary text-xl">
            Enjoy a 7-day free trial of our managed-service plan.
          </p>
        </div>

        <div className="mt-6 flex justify-around space-x-2">
          <div className="bg-layer1 flex h-60 w-1/3 flex-col items-center rounded-xs p-6">
            <p className="h-1/4 text-lg font-bold">Free Tier</p>
            <p className="text-chariot-text-secondary h-1/2 text-center">
              Enter one domain for asset and risk discovery
            </p>
            <button
              className="bg-layer2 text-chariot-text-secondary mt-4 h-1/4 cursor-not-allowed rounded-xs px-4 py-2"
              disabled
            >
              Current Plan
            </button>
          </div>

          <div className="bg-layer1 flex h-60 w-1/3 flex-col items-center rounded-xs p-6">
            <p className="h-1/4 text-lg font-bold">Unmanaged</p>
            <p className="text-chariot-text-secondary h-1/2 text-center">
              Enter unlimited domains for asset and risk discovery
            </p>
            <button
              onClick={e => {
                e.preventDefault();
                contactUs();
              }}
              className="border-brand-light text-brand mt-4 h-1/4 rounded-xs border px-4 py-2"
            >
              Contact Us
            </button>
          </div>

          <div className="border-brand bg-layer1 flex h-60 w-1/3 flex-col items-center rounded-xs border p-6">
            <p className="h-1/4 text-lg font-bold">Managed</p>
            <p className="text-chariot-text-secondary h-1/2 text-center">
              Unlimited domains + expert risk assessment
            </p>
            <button
              onClick={e => {
                e.preventDefault();
                contactUs();
              }}
              className="border-brand-light text-brand mt-4 h-1/4 rounded-xs border px-4 py-2"
            >
              Contact Us
            </button>
          </div>
        </div>
        <p className="text-md text-chariot-text-secondary mt-12 text-center">
          Our team will contact you within 24 hours to start your managed
          service trial.
        </p>
      </div>
    </Modal>
  );
};
